import { render, staticRenderFns } from "./DifficultyMain.vue?vue&type=template&id=6518f66d&scoped=true"
import script from "./DifficultyMain.vue?vue&type=script&lang=js"
export * from "./DifficultyMain.vue?vue&type=script&lang=js"
import style0 from "./DifficultyMain.vue?vue&type=style&index=0&id=6518f66d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518f66d",
  null
  
)

export default component.exports